



















import Vue from 'vue'
import { GetMyOffer } from './InterviewerEntersRoom.graphql'

export default Vue.extend({
  apollo: {
    offers: {
      query: GetMyOffer,
      variables() {
        return {
          id: this.offerId,
        }
      },
    },
  },
  data() {
    return {
      offers: { nodes: [] },
    }
  },
  props: {
    offerId: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: Object,
    },
  },
})
